/**
 * pageName is ApplicationName:Acronym:PageName, matching the GTM cheat sheet.
 * Click ids are built in code as {pageName}:{PascalCaseLabel} from data-trackid.
 */

export const GTM_PAGE_NAME_PREFIX = "IARewards:RWDWUI";
export const PROMOTION_DETAILS_MODAL = `${GTM_PAGE_NAME_PREFIX}:PromotionDetailsModal`;
export const UPCOMING_PROMOTION_MODAL = `${GTM_PAGE_NAME_PREFIX}:UpcomingPromotionModal`;
export const PENDING_PROMOTION_MODAL = `${GTM_PAGE_NAME_PREFIX}:PendingPromotionModal`;
export const CANCEL_CONFIRMATION_MODAL = `${GTM_PAGE_NAME_PREFIX}:CancelConfirmationModal`;
export const PRIZE_CELEBRATION_MODAL = `${GTM_PAGE_NAME_PREFIX}:PrizeCelebrationModal`;

export const GTM_PAGE_NAMES = Object.freeze({
  "/": `${GTM_PAGE_NAME_PREFIX}:Landing`,
  "/home": `${GTM_PAGE_NAME_PREFIX}:Home`,
  "/game": `${GTM_PAGE_NAME_PREFIX}:Game`,
  "/bankingDetails": `${GTM_PAGE_NAME_PREFIX}:BankingDetails`,
  "/taxForm": `${GTM_PAGE_NAME_PREFIX}:TaxForm`,
  "/onboarding": `${GTM_PAGE_NAME_PREFIX}:Onboarding`,
  "/earnings": `${GTM_PAGE_NAME_PREFIX}:Earnings`,
  "/error": `${GTM_PAGE_NAME_PREFIX}:Error`,
  "/accessDenied": `${GTM_PAGE_NAME_PREFIX}:AccessDenied`,
  "/sessionExpired": `${GTM_PAGE_NAME_PREFIX}:SessionExpired`,
  "/ecamsLogin": `${GTM_PAGE_NAME_PREFIX}:EcamsLogin`,
  "/logout": `${GTM_PAGE_NAME_PREFIX}:Logout`,
  "/privacyPolicy": `${GTM_PAGE_NAME_PREFIX}:PrivacyPolicy`,
  "/termsOfUse": `${GTM_PAGE_NAME_PREFIX}:TermsOfUse`,
  "/rewardsOffline": `${GTM_PAGE_NAME_PREFIX}:RewardsOffline`,
});

const PROMOTION_TRACK_IDS = Object.freeze({
  PERSONALAUTO: "select-personal-auto",
  COMMERCIALAUTO: "select-commercial-auto",
  COMMERCIALTRUCKING: "select-commercial-trucking",
  RECREATIONAL: "select-recreational",
});

export function normalizePathname(pathname) {
  if (!pathname) {
    return "/";
  }
  let end = pathname.length;
  while (end > 0 && pathname.charAt(end - 1) === "/") {
    end -= 1;
  }
  const trimmed = pathname.slice(0, end);
  return trimmed === "" ? "/" : trimmed;
}

export function getPageName(pathname) {
  const path = normalizePathname(pathname);
  if (GTM_PAGE_NAMES[path]) {
    return GTM_PAGE_NAMES[path];
  }

  const segment = path.replace(/^\//, "").replace(/[^A-Za-z0-9]+/g, "");
  const viewName = segment
    ? segment.charAt(0).toUpperCase() + segment.slice(1)
    : "Unknown";
  return `${GTM_PAGE_NAME_PREFIX}:${viewName}`;
}

export function kebabToPascal(value) {
  const parts = String(value || "")
    .split("-")
    .filter(Boolean);
  if (parts.length === 0) {
    return "Unnamed";
  }
  return parts
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");
}

export function buildWireId(pageName, trackId) {
  return `${pageName}:${kebabToPascal(trackId)}`;
}

export function promotionTrackId(lineOfBusiness, duplicateIndex = 0) {
  const key = String(lineOfBusiness || "").toUpperCase();
  const base = PROMOTION_TRACK_IDS[key] || "select-promotion";
  return duplicateIndex > 0 ? `${base}-${duplicateIndex + 1}` : base;
}
